import React, { useContext } from 'react'
import { ZoomContext } from 'oio-react'
import PropTypes from 'prop-types'
import RichText from 'src/components/utils/RichText'
import { useOrganization } from 'src/graphql/hooks'
import style from 'src/style'

const RichTextElement = ({ body }) => {
   const { organization } = useOrganization()
   const zoomContext = useContext(ZoomContext)

   const stylesheet = style.stylesheet({
      ...organization.typeStyles,
      zoom: zoomContext.zoom || 1
   })

   return (
      <RichText
         html={body}
         stylesheet={stylesheet}
      />
   )
}

RichTextElement.propTypes = {
   body: PropTypes.string
}

RichTextElement.defaultProps = {
   body: ''
}

export default React.memo(RichTextElement)
